import createHistory from 'history/createBrowserHistory'
import { I18n } from 'lib/i18n'
import React from 'react'
import { DragDropContext } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'
import { Provider } from 'react-redux'
import { ConnectedRouter, routerMiddleware } from 'react-router-redux'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/src/scss/main.scss'
import { applyMiddleware, compose, createStore } from 'redux'
import { createLogger } from 'redux-logger'
import { createEpicMiddleware } from 'redux-observable'
import { epic, reducer } from 'redux/app'
import translations from 'redux/i18n.yaml'
import 'styles/custom.sass'
import Routes from './Routes'

let composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const epicMiddleware = createEpicMiddleware(epic)
const history = createHistory()

const loggerMiddleware = createLogger({ duration: true, collapsed: true })

let store = createStore(
  reducer,
  composeEnhancers(applyMiddleware(epicMiddleware, loggerMiddleware, routerMiddleware(history))),
)

if (process.env.NODE_ENV !== 'production') {
  if (module.hot) {
    console.debug('HMR ENABLED')
    module.hot.accept('./redux/app', () => {
      store.replaceReducer(reducer)
    })
  }
}
I18n.loadTranslations(translations)
I18n.setLocale('de')

class App extends React.Component {
  render() {
    return (
      <div className="App">
        <Provider store={store}>
          <div>
            <ToastContainer
              position="top-center"
              type="success"
              autoClose={3000}
              hideProgressBar={true}
            />
            <ConnectedRouter history={history}>
              <Routes/>
            </ConnectedRouter>
          </div>
        </Provider>
      </div>
    )
  }
}

export default DragDropContext(HTML5Backend)(App)



// WEBPACK FOOTER //
// ./src/App.js